var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scale',{attrs:{"model_score":_vm.keyboard_score,"model_comment":_vm.keyboard_comment,"section":_vm.section,"contents":_vm.contents,"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }